import React, { useState, useCallback, useEffect } from 'react';
// import axios from 'axios';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import Map from '../components/Map'
import PreviewLand from '../components/PreviewLand';
import '../css/AddLand.css';
import { HOME_CONSTANT } from '../constants/Home';
import { COMMON_CONSTANTS } from '../constants/Common';
import { useNavigate } from 'react-router-dom';
import { AXIOS_HELPERS } from '../helpers/Axios';

const { config: { base_url, image_mimeType } } = COMMON_CONSTANTS;
const { country, states } = HOME_CONSTANT;
const { MakeAxiosCall } = AXIOS_HELPERS
const TRANSACTION_TYPES = [
  { value: 'sale', label: 'Sale' },
  { value: 'lease', label: 'Lease' }
];

const LAND_TYPES = [
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'Residential', label: 'Residential' },
  { value: 'Commercial', label: 'Commercial' }
];

const POSTED_BY_TYPES = [
  { value: 'owner', label: 'Owner' },
  { value: 'agent', label: 'Agent' },
  { value: 'khetbazaar', label: 'Khetbazaar' }
];

const IRRIGATION_OPTIONS = [
  { value: 'No', label: 'No' },
  { value: 'Yes', label: 'Yes' }
];

const AddLandForm = () => {
  const [location,setLocation]=useState({})

  const initialFormState = {
    address: '',
    transactionType: 'sale',
    landType: 'Agriculture',
    area: '',
    latitude: location?.latitude,
    longitude: location?.longitude,
    pricePerAcer: '',
    pincode: '',
    landDescription: '',
    postedBy: '',
    landOwnerName: '',
    landOwnerPhone: '',
    isIrrigated: 'Yes',
    file: null,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [state, setState] = useState('');
  const [district, setDistrict] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [isPreviewing, setIsPreviewing] = useState(false)

  const navigate = useNavigate()
// console.log("Initial data------>",initialFormState)
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn')
    // console.log('is logged in', isLoggedIn)
    if (!isLoggedIn) {
      navigate('/login')
    }


  }, [navigate])

  useEffect(() => {
    if (location) {
      setFormData((prev) => ({
        ...prev,
        latitude: location.latitude,
        longitude: location.longitude,
      }));
    }
  }, [location]);
  

  const handleChange = useCallback((e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      const file = files[0];
      // console.log('file', file, image_mimeType)
      if (!image_mimeType?.includes(file?.type)) {
        // console.log('myme type', file?.type)
        setError(`Image Format [ png, jpeg ] is allowed`)
        return
      }
      // if (file && file.size > 20 * 1024) {
      //   // alert('File size should be less than 20KB.');
      //   setError('File size should be less than 20kb.')
      //   return;
      // }
      setFormData(prev => ({ ...prev, [name]: file }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  }, []);


  const resetForm = useCallback(() => {
    setFormData(initialFormState);
    setState('');
    setDistrict('');
    setError('');
    setIsPreviewing(false)
  }, []);  //eslint-disable-line

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    const formDataToSend = new FormData();
    Object.entries({ ...formData, state, district }).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formDataToSend.append(key, value);
      }
    });

    try {
      const options = {
        url: `${base_url}/registerland`,
        data: formDataToSend,
        headers: { "Content-Type": "multipart/form-data" },
        maxBodyLength: Infinity,
        method: 'POST'
      }

      // console.log('register land=========>', options)
      await MakeAxiosCall(options)

      alert('Land added successfully!');
      resetForm();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to register land. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handlePreview = e => {
    e.preventDefault();
    if (!formData.file) {
      setError('Please upload an image.');
      return;
    }
    setError('');
    setIsPreviewing(true);
  };

    // New: Only exit preview, keep formData intact
    const handleEdit = () => {
      setError('');
      setIsPreviewing(false);
    };

  const renderSelect = useCallback(({ name, value, options, onChange = handleChange, disabled = false }) => (
    <select
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled || isSubmitting}
      required
    >
      <option value="">Select {name}</option>
      {options.map(({ value, label }) => (
        <option key={value} value={value}>{label}</option>
      ))}
    </select>
  ), [handleChange, isSubmitting]);

  const renderInput = useCallback(({ type = 'text', name, value, required = true }) => (
    <input
      type={type}
      name={name}
      value={value}
      onChange={handleChange}
      disabled={isSubmitting}
      required={required}
    />
  ), [handleChange, isSubmitting]);

    // Form renderers here…

    if (isPreviewing) {
      return (
        <>
          <NavbarComponent />
          <PreviewLand
            formData={formData}
            stateName={state}
            district={district}
            onEdit={handleEdit}
            onConfirm={handleSubmit}
            isSubmitting={isSubmitting}
            error={error}
          />
          <FooterComponent />
        </>
      );
    }

  return (
    <>
      <NavbarComponent />
      <div className="add-land-container">
        <div className="add-land-form">
          <h2>Register Your Land</h2>
          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handlePreview} className="form-container">
            <div className="form-group">
              <label>Upload Land Image</label>
              <input
                type="file"
                name="file"
                onChange={handleChange}
                disabled={isSubmitting}
                required
              />
            </div>

            <div className="form-group">
              <label>State</label>
              {renderSelect({
                name: 'state',
                value: state,
                options: country?.india?.map(state => ({ value: state, label: state })) || [],
                onChange: (e) => setState(e.target.value)
              })}
            </div>

            <div className="form-group">
              <label>District</label>
              {renderSelect({
                name: 'district',
                value: district,
                options: states[state]?.map(district => ({ value: district, label: district })) || [],
                onChange: (e) => setDistrict(e.target.value),
                disabled: !state
              })}
            </div>

            <div className="form-group">
              <label>Address</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                disabled={isSubmitting}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Listing Type</label>
                {renderSelect({
                  name: 'transactionType',
                  value: formData.transactionType,
                  options: TRANSACTION_TYPES
                })}
              </div>

              <div className="form-group">
                <label>Posted By</label>
                {renderSelect({
                  name: 'postedBy',
                  value: formData.postedBy,
                  options: POSTED_BY_TYPES
                })}
              </div>
            </div>

            {(formData.postedBy === "agent" || formData.postedBy === "khetbazaar") && (
              <div className="form-group">
                <label>Land Owner Phone</label>
                {renderInput({
                  name: 'landOwnerPhone',
                  value: formData.landOwnerPhone
                })}
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label>Land Owner Name</label>
                {renderInput({
                  name: 'landOwnerName',
                  value: formData.landOwnerName
                })}
              </div>

              <div className="form-group">
                <label>Property Type</label>
                {renderSelect({
                  name: 'landType',
                  value: formData.landType,
                  options: LAND_TYPES
                })}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Is Irrigated</label>
                {renderSelect({
                  name: 'isIrrigated',
                  value: formData.isIrrigated,
                  options: IRRIGATION_OPTIONS
                })}
              </div>

              <div className="form-group">
                <label>Pincode</label>
                {renderInput({
                  name: 'pincode',
                  value: formData.pincode
                })}
              </div>
            </div>

           <div className='form-row'>
           <div className="form-group">
              <label>Land Description</label>
              <textarea
                name="landDescription"
                value={formData.landDescription}
                onChange={handleChange}
                disabled={isSubmitting}
                required
              />
            </div>
            <div className='form-group'>
            <Map setLocation={setLocation}/>
            </div>
           </div>



            {/* <div className="form-row">
              <div className="form-group" id='latitude-id'>
                <label>Latitude</label>
                {renderInput({
                  name: 'latitude',
                  value: formData.latitude,
                  required: false
                })}
              </div>

              <div className="form-group" id='longitude-id'>
                <label>Longitude</label>
                {renderInput({
                  name: 'longitude',
                  value: formData.longitude,
                  required: false

                })}
              </div>
            </div> */}

            <div className="form-row">
              <div className="form-group">
                <label>Area (in acre)</label>
                {renderInput({
                  type: 'number',
                  name: 'area',
                  value: formData.area
                })}
              </div>

              <div className="form-group">
                <label>Price per Acre (in Lakhs)</label>
                {renderInput({
                  type: 'number',
                  name: 'pricePerAcer',
                  value: formData.pricePerAcer
                })}
              </div>
            </div>

            <button type="submit" disabled={isSubmitting}>
              {/* {isSubmitting ? 'Registering...' : 'Register Land'} */}
              {isSubmitting ? 'Registering...' : 'Preview'}
            </button>
          </form>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};

export default AddLandForm;